import React, { useState, useEffect, useMemo, useRef } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import Chip from "@mui/material/Chip";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import { ReactComponent as DropdownIcon } from "../../assets/images/icons/logs/dropdown-arrow.svg";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Divider, TextField } from "@mui/material";
import { MenuItem } from "@mui/material";
import { Select } from "@mui/material";
import { Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import ButtonGroup from "@mui/material/ButtonGroup";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  WHATSAPP_MARKETING_LOG_ENDPOINT,
  WHATSAPP_MARKETING_LOG_EXPORT_ENDPOINT,
  API_BASE_URL,
} from "../../config/urls";
import Menu from "@mui/material/Menu";
import CheckIcon from "@mui/icons-material/Check";
import MessageIcon from "@mui/icons-material/Message";
import FlagIcon from "@mui/icons-material/Flag";
import EventIcon from "@mui/icons-material/Event";
import Tooltip from "@mui/material/Tooltip";
import InputAdornment from "@mui/material/InputAdornment";
import { Download, Search } from "@mui/icons-material";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useAuth } from "../../hooks/AuthProvider";
import useLogExport from "../../hooks/useLogExport";
import { FilterModal, FilterModalItem } from "../FilterModal";
import { CalendarIcon } from "@mui/x-date-pickers";
import TableFilterButton from "../TableFilterButton";
import TableSearchInput from "../TableSearchInput";
import ExportButton from "../ExportButton";
import { ColorsConstants, searchBarWidth } from "../../cssUtils/constants";
import ButtonOne from "../../common/normal-button";
import AppTable from "../../common/app-table";
import ButtonTwo from "../../common/dashboard-button";
import AppDropdown from "../../common/app-dropdown";
import { loadFilters, saveFilters, FILTER_NAMESPACES } from "../../utils/filterStorage";
import {
  resolveLogPhoneSearchQueryForApi,
  normalizeCombinedSearchInput,
} from "../../utils/phoneSearch";
import { formatWithTzLabel } from "../../utils/dateUtils";

const columns = [
  { id: "phone_number", label: "Phone Number", minWidth: 160 },
  { id: "datetime", label: "DateTime", minWidth: 180 },
  { id: "status", label: "Status", minWidth: 120 },
  { id: "message_type", label: "Message Type", minWidth: 160 },
  { id: "template", label: "Template", minWidth: 180 },
  { id: "description", label: "Description", minWidth: 300 },
  { id: "option", label: "Option", minWidth: 140 },
  { id: "campaign", label: "Campaign", minWidth: 200 },
  { id: "created_by", label: "Created By", minWidth: 180 },
];

export default function MarketingLogsTable({
  refreshKey,
  dateInput,
  controller,
  setController,
  lastSynced,
  setLastSynced,
}) {
  const [rowCount, setRowCount] = useState(0);
  const [messageData, setmessageData] = useState([]);
  const messageTypeOptions = [
  ...new Set(
    messageData
      .map((item) => item.message_type)
      .filter(Boolean)
  ),
].map((type) => ({
  label: type.charAt(0).toUpperCase() + type.slice(1),
  value: type,
}));
  const [userModalState, setUserModalState] = useState({
    isOpen: false,
    selectedClient: null,
    mode: "add",
  });
  const URL = API_BASE_URL;

  const capitalizeFirstLetter = (str) => {
    return str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";
  };

  const [savedFilters] = useState(() => {
    const s = loadFilters(FILTER_NAMESPACES.MARKETING_LOGS, {
      searchQuery: '', statusFilter: '', optionFilter: '', messageTypeFilter: "", fromDate: null, toDate: null,
      templateFilter: '', templateName: '', createdByFilter: '',
    });
    return {
      ...s,
      fromDate: s.fromDate ? dayjs(s.fromDate) : null,
      toDate: s.toDate ? dayjs(s.toDate) : null,
    };
  });
  const [searchQuery, setSearchQuery] = useState(savedFilters.searchQuery);
  const [charCount, setCharCount] = useState(savedFilters.searchQuery.length);
  const [statusFilter, setStatusFilter] = useState(savedFilters.statusFilter);
  const [optionFilter, setOptionFilter] = useState(
  savedFilters.optionFilter || ""
);
  const [messageTypeFilter, setMessageTypeFilter] = useState(
    savedFilters.messageTypeFilter || ""
  );
  const [fromDate, setFromDate] = useState(savedFilters.fromDate);
  const [toDate, setToDate] = useState(savedFilters.toDate);
  const [dateError, setDateError] = useState(null);
  const { getValidToken } = useAuth();

  const [dateAnchorEl, setDateAnchorEl] = useState(null);
  const [appliedDateRange, setAppliedDateRange] = useState([savedFilters.fromDate, savedFilters.toDate]);

  const [messageTypeAnchorEl, setMessageTypeAnchorEl] = useState(null);
  const [statusAnchorEl, setStatusAnchorEl] = useState(null);
  const [senderAnchorEl, setSenderAnchorEl] = useState(null);
  const [receiverAnchorEl, setReceiverAnchorEl] = useState(null);
  const [optionAnchorEl, setOptionAnchorEl] = useState(null);

  const [filterModalOpen, setFilterModalOpen] = useState(false);

  // To track export button state
  const [exportState, setExportState] = useState("default");
  const [sortState, setSortState] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [templatesLoading, setTemplatesLoading] = useState(false);
  const [templateSearchQuery, setTemplateSearchQuery] = useState("");
  const [templateFilter, setTemplateFilter] = useState(savedFilters.templateFilter || "");
  const [templateName, setTemplateName] = useState(savedFilters.templateName || "");
  const [createdByList, setCreatedByList] = useState([]);
  const [createdByLoading, setCreatedByLoading] = useState(false);
  const [createdByFilter, setCreatedByFilter] = useState(savedFilters.createdByFilter || "");

  // const options = [...new Set(messageData.map(data => data.option))].map(option => (
  //         <MenuItem key={option} value={option}>{option?.toUpperCase()}</MenuItem>
  //     ));

  const options = [
    ...new Set(
      messageData.map((data) => data.option).filter((option) => option),
    ),
  ].map((option) => (
    <MenuItem key={option} value={option}>
      {option ? option.toUpperCase() : ""}
    </MenuItem>
  ));

  const statuses = [
    ...new Set(
      messageData.map((data) => data.status).filter((status) => status),
    ),
  ].map((status) => (
    <MenuItem key={status} value={status}>
      {capitalizeFirstLetter(status)}
    </MenuItem>
  ));

  const resolvedMarketingSearch = useMemo(
    () => resolveLogPhoneSearchQueryForApi(searchQuery),
    [searchQuery],
  );

  const activeFilters = useMemo(
    () => ({
      log_type: "marketing",
      search_query: resolvedMarketingSearch.blockFetch ? "" : resolvedMarketingSearch.apiSearchQuery,
      status_filter: statusFilter,
      option_filter: optionFilter,
      message_type_filter: messageTypeFilter,
      from_date: fromDate ? dayjs(fromDate).format("YYYY-MM-DD") : "",
      to_date: toDate ? dayjs(toDate).format("YYYY-MM-DD") : "",
      template_filter: templateFilter,
      created_by_filter: createdByFilter,
    }),
    [resolvedMarketingSearch, statusFilter, messageTypeFilter, optionFilter, fromDate, toDate, templateFilter, createdByFilter],
  );

  const {
    preview: exportPreview,
    loading: exportLoading,
    error: exportError,
    triggerExport,
  } = useLogExport(activeFilters);

  const [exportSnackbar, setExportSnackbar] = useState({ open: false, message: "", severity: "info" });

  const wasExportLoadingRef = useRef(false);
  useEffect(() => {
    if (exportLoading) {
      setExportState("loading");
    } else if (wasExportLoadingRef.current) {
      setExportState(exportError ? "failed" : "success");
    }
    wasExportLoadingRef.current = exportLoading;
  }, [exportLoading, exportError]);

  const showExportSnackbar = (message, severity = "info") => {
    setExportSnackbar({ open: true, message, severity });
  };

  const handleCloseExportSnackbar = () => {
    setExportSnackbar((prev) => ({ ...prev, open: false }));
  };

  const sortedData = useMemo(() => {
    if (!sortState.length || !messageData.length) return messageData;
    return [...messageData].sort((a, b) => {
      for (const { id, direction } of sortState) {
        let aVal = a[id];
        let bVal = b[id];
        if (aVal == null && bVal == null) continue;
        if (aVal == null) return direction === "asc" ? 1 : -1;
        if (bVal == null) return direction === "asc" ? -1 : 1;
        if (typeof aVal === "string") { aVal = aVal.toLowerCase(); bVal = String(bVal).toLowerCase(); }
        if (aVal < bVal) return direction === "asc" ? -1 : 1;
        if (aVal > bVal) return direction === "asc" ? 1 : -1;
      }
      return 0;
    });
  }, [messageData, sortState]);

  useEffect(() => {
    saveFilters(FILTER_NAMESPACES.MARKETING_LOGS, {
      searchQuery,
      statusFilter,
      messageTypeFilter,
      optionFilter,
      templateFilter,
      templateName,
      createdByFilter,
      fromDate: fromDate ? dayjs(fromDate).toISOString() : null,
      toDate: toDate ? dayjs(toDate).toISOString() : null,
    });
  }, [searchQuery, statusFilter, messageTypeFilter, optionFilter, templateFilter, templateName, createdByFilter, fromDate, toDate]);

  const fetchData = async () => {
    console.log("searchQuery", searchQuery);
    console.log("resolvedMarketingSearch", resolvedMarketingSearch);
    if (resolvedMarketingSearch.blockFetch) {
      setmessageData([]);
      setRowCount(0);
      setLastSynced(null);
      return;
    }
    let searchDateURL = "";
    if (dateInput) {
      let dateString = dayjs(dateInput).format("YYYY-MM-DD");
      searchDateURL = `&search_date=${dateString}`;
    }

    // Construct query parameters for server-side filtering and pagination
    const queryParams = new URLSearchParams({
      limit: controller.rowsPerPage.toString(),
      offset: (
        ((controller.serverSidePage ?? controller.page ?? 0) *
        controller.rowsPerPage)
      ).toString(),
      search_query: resolvedMarketingSearch.apiSearchQuery,
      status_filter: statusFilter,
      option_filter: optionFilter,
      message_type_filter: messageTypeFilter,
      from_date: fromDate ? dayjs(fromDate).format("YYYY-MM-DD") : "",
      to_date: toDate ? dayjs(toDate).format("YYYY-MM-DD") : "",
      template_filter: templateFilter,
      created_by_filter: createdByFilter,
    });
    console.log(queryParams.toString());
    const tenant = localStorage.getItem("tenant");

    const headers = {
      //   "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "X-Tenant-Id": tenant,
    };

    try {
      const response = await fetch(
        `${WHATSAPP_MARKETING_LOG_ENDPOINT}?${queryParams}${searchDateURL}`,
        { headers },
      );
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const jsonData = await response.json();

      console.log("JSON Data: ", jsonData);

      setmessageData(jsonData.results);
      setRowCount(jsonData.count);
      setLastSynced(
        jsonData.results.length > 0
          ? formatWithTzLabel(
              jsonData.results[0].last_synced,
              "MMMM D, YYYY, h:mm:ss A",
            )
          : null,
      );
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  // const handleExport = async () => {
  //     try {
  //         setExportState("loading");
  //         const token = await getValidToken();
  //         const tenant = localStorage.getItem('tenant');

  //         // Construct query parameters for filtering
  //         const queryParams = new URLSearchParams({
  //             search_query: searchQuery,
  //             status_filter: statusFilter,
  //             option_filter: optionFilter,
  //             from_date: fromDate ? dayjs(fromDate).format("YYYY-MM-DD") : '',
  //             to_date: toDate ? dayjs(toDate).format("YYYY-MM-DD") : ''
  //         });

  //         console.log("export URL: ", `${WHATSAPP_MARKETING_LOG_EXPORT_ENDPOINT}?${queryParams}`);

  //         // Make API request to export endpoint
  //         const response = await fetch(`${WHATSAPP_MARKETING_LOG_EXPORT_ENDPOINT}?${queryParams}`, {
  //             headers: {
  //             'Authorization': `Bearer ${token}`,
  //             "X-Tenant-Id": tenant
  //             }
  //         });

  //         if (!response.ok) {
  //             throw new Error('Failed to export data');
  //         }

  //         // Create a blob from the response
  //         const blob = await response.blob();

  //         // Create a link element to download the file
  //         const url = window.URL.createObjectURL(blob);
  //         const a = document.createElement('a');
  //         a.style.display = 'none';
  //         a.href = url;

  //         // Use the current date for the filename
  //         const today = new Date();
  //         const dateStr = today.toISOString().split('T')[0];
  //         a.download = `broadcast-log-data-${dateStr}.csv`;

  //         // Append to the document and trigger download
  //         document.body.appendChild(a);
  //         a.click();

  //         // Set the export state to "success"
  //         setExportState("success");

  //         // Clean up
  //         window.URL.revokeObjectURL(url);
  //         document.body.removeChild(a);
  //     } catch (error) {
  //         console.error('Error exporting data:', error.message);
  //         setExportState("failed");
  //     }
  // };

  const handleExport = () => {
    if (resolvedMarketingSearch.blockFetch) {
      setExportState("failed");
      return;
    }

    if (!exportPreview) {
      showExportSnackbar("Still calculating export size, please try again in a moment.", "warning");
      return;
    }

    showExportSnackbar(
      exportPreview.message,
      exportPreview.export_mode === "blocked" ? "error" : "info",
    );

    if (exportPreview.export_mode === "blocked") {
      return;
    }

    triggerExport();
  };

  useEffect(() => {
    fetchData();
  }, [
    controller,
    controller.serverSidePage,
    controller.rowsPerPage,
    refreshKey,
    dateInput,
    searchQuery,
    statusFilter,
    optionFilter,
    messageTypeFilter,
    templateFilter,
    createdByFilter,
    fromDate,
    toDate,
    lastSynced,
  ]);

  useEffect(() => {
    // Initialize appliedDateRange with current fromDate and toDate
    setAppliedDateRange([fromDate, toDate]);
  }, []);

  const handleDateClick = (event) => {
    setDateAnchorEl(event.currentTarget);
  };

  const handleDateRangeApply = () => {
    // Apply the current date range and update the fromDate/toDate variables
    setFromDate(appliedDateRange[0]);
    setToDate(appliedDateRange[1]);
    setDateAnchorEl(null);
    setController({
      page: 0,
      rowsPerPage: 20,
    });
  };

  const handleDateRangeCancel = () => {
    // Reset the temporary date range to match current applied dates
    setAppliedDateRange([fromDate, toDate]);
    setDateAnchorEl(null);
    setController({
      page: 0,
      rowsPerPage: 20,
    });
  };

  const handleMessageTypeClick = (event) => {
    setMessageTypeAnchorEl(event.currentTarget);
  };

  const handleSenderClick = (event) => {
    setSenderAnchorEl(event.currentTarget);
  };

  const handleReceiverClick = (event) => {
    setReceiverAnchorEl(event.currentTarget);
  };

  const handleMessageTypeSelect = (type) => {
      const newValue = messageTypeFilter === type ? "" : type;

  setMessageTypeFilter(newValue);
  setController((prev) => ({
    ...prev,
    page: 0,
    serverSidePage: 0,
  }));
  };

  const handleSenderSelect = (value) => {
    setSenderAnchorEl(null);
  };

  const handleReceiverSelect = (value) => {
    setReceiverAnchorEl(null);
  };

  const fetchTemplates = async () => {
    setTemplatesLoading(true);
    try {
      const token = await getValidToken();
      const tenant = localStorage.getItem("tenant");
      const response = await fetch(`${URL}/templates/names`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "X-Tenant-Id": tenant,
        },
      });
      if (!response.ok) throw new Error(`Failed to fetch templates: ${response.status}`);
      const data = await response.json();
      const activeTemplates = data.results.filter(
        (t) => t.active && t.status === "APPROVED",
      );
      setTemplates(activeTemplates);
    } catch (error) {
      console.error("Error fetching templates:", error);
      setTemplates([]);
    } finally {
      setTemplatesLoading(false);
    }
  };

  const handleTemplateSelect = (template) => {
    if (templateFilter === template.template_id) {
      setTemplateFilter("");
      setTemplateName("");
    } else {
      setTemplateFilter(template.template_id);
      setTemplateName(template.template_name);
    }
    setController({ page: 0, rowsPerPage: 20 });
  };

  const fetchCreatedByList = async () => {
    setCreatedByLoading(true);
    try {
      const token = await getValidToken();
      const tenant = localStorage.getItem("tenant");
      const response = await fetch(`${URL}/logs/whatsapp/broadcast/created-by/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "X-Tenant-Id": tenant,
        },
      });
      if (!response.ok) throw new Error(`Failed to fetch creators: ${response.status}`);
      const data = await response.json();
      setCreatedByList(data.results || []);
    } catch (error) {
      console.error("Error fetching created by list:", error);
      setCreatedByList([]);
    } finally {
      setCreatedByLoading(false);
    }
  };

  const handleCreatedBySelect = (creatorId) => {
    const newValue = createdByFilter === creatorId ? "" : creatorId;
    setCreatedByFilter(newValue);
    setController((prev) => ({ ...prev, page: 0 }));
  };

  useEffect(() => {
    fetchTemplates();
    fetchCreatedByList();
  }, []);

  const updateSearchValue = (value) => {
    const normalized = normalizeCombinedSearchInput(value);
    if (normalized.length > 50) {
      return;
    }
    setSearchQuery(normalized);
    setCharCount(normalized.length);
    setController({
      page: 0,
      rowsPerPage: 20,
    });
  };

  const handleOptionClick = (event) => {
    setOptionAnchorEl(event.currentTarget);
  };

  const handleOptionSelect = (option) => {
    const newValue = optionFilter === option ? "" : option;
    setOptionFilter(newValue);
    setOptionAnchorEl(null);
    setController({
      page: 0,
      rowsPerPage: 20,
    });
  };

  // And modify the existing status handler to match the pattern above
  const handleStatusClick = (event) => {
    setStatusAnchorEl(event.currentTarget);
  };

  const handleStatusSelect = (status) => {
    const newValue = statusFilter === status ? "" : status;
    setStatusFilter(newValue);
    setStatusAnchorEl(null);
    setController({
      page: 0,
      rowsPerPage: 20,
    });
  };

  const handlePageChange = (event, newPage) => {
    setController((prev) => ({
      ...prev,
      page: newPage,
      serverSidePage: newPage, // Sync server-side page with UI page
    }));
  };

  const handleOptionFilterChange = (event) => {
    setOptionFilter(event.target.value);
  };

  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
  };

  const handleChangeRowsPerPage = (event) => {
    setController((prev) => ({
      ...prev,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
      serverSidePage: 0,
    }));
  };

  const handleFromDateChange = (newValue) => {
    if (toDate && newValue && dayjs(newValue).isAfter(toDate)) {
      setDateError("From Date must be less than or equal to To Date");
    } else {
      setDateError(null);
      setFromDate(newValue);
    }
  };

  const handleToDateChange = (newValue) => {
    if (fromDate && newValue && dayjs(newValue).isBefore(fromDate)) {
      setDateError("To Date must be greater than or equal to From Date");
    } else {
      setDateError(null);
      setToDate(newValue);
    }
  };

  const handleRefresh = () => {
    setController({
      page: 0,
      rowsPerPage: 20,
    });
  };

  const handleResetButtonClick = () => {
    setSearchQuery("");
    setStatusFilter("");
    setOptionFilter("");
    setMessageTypeFilter("");
    setTemplateFilter("");
    setTemplateName("");
    setCreatedByFilter("");
    setAppliedDateRange([null, null]);
    setFromDate(null);
    setToDate(null);
    setSortState([]);
    setController({
      page: 0,
      rowsPerPage: 20,
    });
  };

  const handleSortChange = (columnId) => {
    setSortState((prev) => {
      const existing = prev.find((s) => s.id === columnId);
      if (!existing) return [...prev, { id: columnId, direction: "asc" }];
      if (existing.direction === "asc") return prev.map((s) => s.id === columnId ? { ...s, direction: "desc" } : s);
      return prev.filter((s) => s.id !== columnId);
    });
  };

  const getTotalActiveFilters = () => {
    let count = 0;
    if (statusFilter) count++;
    if (optionFilter) count++;
    if (messageTypeFilter) count++;
    if (templateFilter) count++;
    if (createdByFilter) count++;
    if (fromDate) count++;
    if (toDate) count++;
    return count;
  };

  const tableColumns = [
    { id: "receiver", label: "To", minWidth: 160, sortable: true },
    {
      id: "logged_at",
      label: "Date",
      minWidth: 180,
      sortable: true,
      render: (message) =>
        formatWithTzLabel(message.logged_at, "MMMM D, YYYY, h:mm A"),
    },
    { id: "status", label: "Status", minWidth: 120, sortable: true },
    { id: "message_type", label: "Message Type", minWidth: 160, sortable: true },
    {
      id: "template",
      label: "Template",
      minWidth: 200,
      render: (message) => message?.template?.template_name,
    },
    { id: "description", label: "Description", minWidth: 200 },
    { id: "option", label: "Broadcast Type", minWidth: 120, sortable: true },
    { id: "broadcast_name", label: "Broadcast Name", minWidth: 180 },
    { id: "campaign", label: "Campaign", minWidth: 160, sortable: true },
    {
      id: "created_by",
      label: "Created By",
      minWidth: 160,
      sortable: true,
      render: (message) => message.created_by || "",
    },
  ];

  return (
    <Paper
      sx={{
        width: "100%",
        overflow: "hidden",
        backgroundColor: "#F7F7F7",
        border: "none",
        boxShadow: "none",
      }}
    >
      <Box
        sx={{
          display: { xs: "flex", md: "none" },
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <ButtonOne
            variant="contained"
            startIcon={<Download />}
            onClick={handleExport}
          >
            Export
          </ButtonOne>
        </Box>
        <Divider />
        <Box
          sx={{
            display: "flex",
            mb: 2,
            gap: 1,
          }}
        >
          <TableSearchInput
            searchQuery={searchQuery}
            onSearchChange={(e) => updateSearchValue(e.target.value)}
            charCount={charCount}
            placeholder="Search by phone no, template, broadcast or campaign"
            tooltip="Search by Phone Number, Template Name, Broadcast Name, or Campaign Name"
            error={Boolean(resolvedMarketingSearch.blockFetch && resolvedMarketingSearch.phoneSearchError)}
            helperText={resolvedMarketingSearch.blockFetch ? resolvedMarketingSearch.phoneSearchError : undefined}
          />
          <TableFilterButton
            setFilterModalOpen={setFilterModalOpen}
            totalActiveFilters={getTotalActiveFilters()}
          />
        </Box>
      </Box>

      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          flexDirection: "column",
          p: 1,
          m: 1,
          mx: 0,
          backgroundColor: "#F7F7F7",
          borderRadius: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            alignItems: "center",
            overflowX: "auto",
            pb: 1,
            "&::-webkit-scrollbar": { height: "8px" },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "rgba(0,0,0,0.2)",
              borderRadius: "4px",
            },
          }}
        >
          {/* Search Filter */}
          <Box sx={{ width: searchBarWidth }}>
            <TableSearchInput
              searchQuery={searchQuery}
              onSearchChange={(e) => updateSearchValue(e.target.value)}
              charCount={charCount}
              placeholder="Search by Phone No, Template, Broadcast or Campaign"
              tooltip="Search by Phone Number, Template Name, Broadcast Name, or Campaign Name"
              error={Boolean(
                resolvedMarketingSearch.blockFetch &&
                  resolvedMarketingSearch.phoneSearchError,
              )}
              helperText={
                resolvedMarketingSearch.blockFetch
                  ? resolvedMarketingSearch.phoneSearchError
                  : undefined
              }
            />
          </Box>

          {/* Date Range Filter */}
          <AppDropdown
            endIcon={<DropdownIcon />}
            sx={{
              whiteSpace: "nowrap",
              minWidth: 180,
              px: 1.2,
            }}
            paperProps={{ maxWidth: "500px" }}
            menuContent={(closeMenu) => (
              <Box sx={{ p: 2 }}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale="en-gb"
                >
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                  >
                    <Typography variant="subtitle2">
                      Select Date Range:
                    </Typography>
                    <Box sx={{ display: "flex", gap: 2 }}>
                      <DatePicker
                        label="From"
                        value={appliedDateRange[0]}
                        onChange={(newValue) => {
                          setAppliedDateRange([newValue, appliedDateRange[1]]);
                          if (
                            appliedDateRange[1] &&
                            newValue &&
                            dayjs(newValue).isAfter(appliedDateRange[1])
                          ) {
                            setDateError(
                              "From Date must be less than or equal to To Date",
                            );
                          } else {
                            setDateError(null);
                          }
                        }}
                        slotProps={{
                          textField: {
                            size: "small",
                            sx: {
                              width: "200px",
                              "& .MuiInputBase-root": { height: "40px" },
                            },
                          },
                        }}
                      />
                      <DatePicker
                        label="To"
                        value={appliedDateRange[1]}
                        onChange={(newValue) => {
                          setAppliedDateRange([appliedDateRange[0], newValue]);
                          if (
                            appliedDateRange[0] &&
                            newValue &&
                            dayjs(newValue).isBefore(appliedDateRange[0])
                          ) {
                            setDateError(
                              "To Date must be greater than or equal to From Date",
                            );
                          } else {
                            setDateError(null);
                          }
                        }}
                        slotProps={{
                          textField: {
                            size: "small",
                            sx: {
                              width: "200px",
                              "& .MuiInputBase-root": { height: "40px" },
                            },
                          },
                        }}
                      />
                    </Box>
                    {dateError && (
                      <Typography variant="caption" color="error">
                        {dateError}
                      </Typography>
                    )}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 1,
                      }}
                    >
                      <Button
                        onClick={() => {
                          handleDateRangeCancel();
                          closeMenu();
                        }}
                        variant="outlined"
                      >
                        CANCEL
                      </Button>
                      <Button
                        onClick={() => {
                          handleDateRangeApply();
                          closeMenu();
                        }}
                        variant="contained"
                        disabled={
                          !appliedDateRange[0] ||
                          !appliedDateRange[1] ||
                          Boolean(dateError)
                        }
                      >
                        APPLY
                      </Button>
                    </Box>
                  </Box>
                </LocalizationProvider>
              </Box>
            )}
          >
            Date Range
            {fromDate && toDate && (
              <Tooltip
                title={`${dayjs(fromDate).format("MM/DD/YYYY")} - ${dayjs(toDate).format("MM/DD/YYYY")}`}
                placement="top"
                arrow
              >
                <Chip
                  label={`${dayjs(fromDate).format("MM/DD/YYYY")} - ${dayjs(toDate).format("MM/DD/YYYY")}`}
                  size="small"
                  onDelete={() => {
                    setFromDate(null);
                    setToDate(null);
                  }}
                  sx={{
                    ml: 1,
                    maxWidth: { sm: "120px", md: "200px" },
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                />
              </Tooltip>
            )}
          </AppDropdown>

          {/* Options Filter */}
          <AppDropdown
            endIcon={<DropdownIcon />}
            menuItems={[
              { label: "Single", value: "single" },
              { label: "Segment", value: "segment" },
              { label: "CSV", value: "csv" },
              { label: "Retry", value: "Retry" },
              { label: "API", value: "API" },
            ]}
            selectedValue={optionFilter}
            onMenuSelect={(value) => handleOptionSelect(value)}
            sx={{ whiteSpace: "nowrap", minWidth: 150, px: 1.2 }}
          >
            Broadcast Type
            {optionFilter && (
              <Tooltip title={optionFilter} placement="top" arrow>
                <Chip
                  label={optionFilter}
                  size="small"
                  onDelete={() => handleOptionSelect(optionFilter)}
                  sx={{
                    ml: 1,
                    maxWidth: "120px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                />
              </Tooltip>
            )}
          </AppDropdown>

          {/* Status Filter */}
          <AppDropdown
            endIcon={<DropdownIcon />}
            menuItems={[
              { label: "Read", value: "read" },
              { label: "Delivered", value: "delivered" },
              { label: "Sent", value: "sent" },
              { label: "Enqueued", value: "enqueued" },
              { label: "Failed", value: "failed" },
            ]}
            selectedValue={statusFilter}
            onMenuSelect={(value) => handleStatusSelect(value)}
            sx={{ whiteSpace: "nowrap", minWidth: 150, px: 1.2 }}
          >
            Status
            {statusFilter && (
              <Tooltip title={statusFilter} placement="top" arrow>
                <Chip
                  label={statusFilter}
                  size="small"
                  onDelete={() => handleStatusSelect(statusFilter)}
                  sx={{
                    ml: 1,
                    maxWidth: "120px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                />
              </Tooltip>
            )}
          </AppDropdown>
          <AppDropdown
          endIcon={<DropdownIcon />}
          menuItems={messageTypeOptions}
          selectedValue={messageTypeFilter}
          onMenuSelect={(value) => handleMessageTypeSelect(value)}
          sx={{ whiteSpace: "nowrap", minWidth: 150, px: 1.2 }}
          >
            Message Type
            {messageTypeFilter && (
              <Tooltip title={messageTypeFilter} placement="top" arrow>
                <Chip
                label={messageTypeFilter}
                size="small"
                onDelete={() => handleMessageTypeSelect(messageTypeFilter)}
                sx={{
                  ml: 1,
                  maxWidth: "120px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                />
                </Tooltip>
              )}
              </AppDropdown>

          {/* Template Filter */}
          <AppDropdown
            endIcon={<DropdownIcon />}
            selectedValue={templateFilter}
            loading={templatesLoading}
            emptyText="No templates available"
            paperProps={{ maxWidth: "400px", maxHeight: "400px" }}
            sx={{ whiteSpace: "nowrap", minWidth: 150, px: 1.2 }}
            menuContent={(closeMenu) => {
              const filteredTemplates = templates.filter((t) =>
                t.template_name.toLowerCase().includes(templateSearchQuery.toLowerCase())
              );
              return (
                <Box sx={{ p: 1 }}>
                  {templates.length > 0 && (
                    <TextField
                      placeholder="Search templates..."
                      value={templateSearchQuery}
                      onChange={(e) => setTemplateSearchQuery(e.target.value)}
                      size="small"
                      sx={{ mb: 1, width: "100%", "& .MuiInputBase-root": { height: "32px" } }}
                    />
                  )}
                  <Box sx={{ maxHeight: "320px", overflow: "auto" }}>
                    {filteredTemplates.length > 0 ? (
                      filteredTemplates.map((template) => (
                        <MenuItem
                          key={template.template_id}
                          onClick={() => {
                            handleTemplateSelect(template);
                            setTemplateSearchQuery("");
                            closeMenu();
                          }}
                          sx={{ whiteSpace: "normal", wordWrap: "break-word" }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                            <Typography variant="body2" sx={{ flexGrow: 1 }}>
                              {template.template_name}
                            </Typography>
                            {templateFilter === template.template_id && (
                              <CheckIcon sx={{ ml: 1 }} color="success" />
                            )}
                          </Box>
                        </MenuItem>
                      ))
                    ) : (
                      <Box sx={{ p: 2, textAlign: "center", color: "gray" }}>
                        No templates found
                      </Box>
                    )}
                  </Box>
                </Box>
              );
            }}
          >
            Template
            {templateName && (
              <Chip
                label={templateName}
                size="small"
                onDelete={() => handleTemplateSelect({ template_id: templateFilter, template_name: templateName })}
                sx={{
                  ml: 1,
                  fontSize: "12px",
                  maxWidth: { sm: "80px", md: "150px" },
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              />
            )}
          </AppDropdown>

          {/* Created By Filter */}
          <AppDropdown
            endIcon={<DropdownIcon />}
            menuItems={createdByList.map((creator) => ({
              label: creator.name,
              value: creator.id,
            }))}
            selectedValue={createdByFilter}
            loading={createdByLoading}
            emptyText="No creators available"
            onMenuSelect={handleCreatedBySelect}
            sx={{ whiteSpace: "nowrap", minWidth: 150, px: 1.2 }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <span>Created By</span>
              {createdByFilter && createdByList.length > 0 && (
                <Chip
                  label={createdByList.find((c) => c.id === createdByFilter)?.name || createdByFilter}
                  size="small"
                  onDelete={() => handleCreatedBySelect(createdByFilter)}
                />
              )}
            </Box>
          </AppDropdown>

          {/* Reset Button */}
          <ButtonTwo
            startIcon={<RefreshIcon />}
            variant="outlined"
            onClick={handleResetButtonClick}
            sx={{
              height: "40px",
              borderRadius: "8px",
              textTransform: "capitalize",
              border: `1px solid ${ColorsConstants.primaryBackgroundColor}`,
              color: ColorsConstants.primaryBackgroundColor,
              minWidth: 110,
              px: 2,
            }}
          >
            Reset
          </ButtonTwo>

          {/* Export Button */}
          <Box sx={{ minWidth: 150, maxWidth: 180 }}>
            <ExportButton
              handleExport={handleExport}
              text="Export"
              state={exportState}
              setState={setExportState}
            />
          </Box>
        </Box>
      </Box>

      {/* Table Section */}
      <AppTable
        columns={tableColumns}
        rows={sortedData}
        rowKey={(message, index) => index}
        emptyMessage="No match found"
        maxHeight={500}
        containerSx={{
          scrollbarWidth: "thin",
          scrollbarColor: "#C5CEDB #F3F6FB",
          "&::-webkit-scrollbar": { width: "8px" },
          "&::-webkit-scrollbar-track": { backgroundColor: "#F3F6FB", borderRadius: "8px" },
          "&::-webkit-scrollbar-thumb": { backgroundColor: "#C5CEDB", borderRadius: "8px" },
          "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#A8B4C7" },
        }}
        count={rowCount}
        page={controller.page}
        rowsPerPage={controller.rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleChangeRowsPerPage}
        sortState={sortState}
        onSortChange={handleSortChange}
      />

      <FilterModal
        open={filterModalOpen}
        onClose={() => setFilterModalOpen(false)}
        onReset={handleResetButtonClick}
      >
        <FilterModalItem
          name="Options"
          data={["single", "segment", "csv"]}
          value={optionFilter}
          onChange={(e) => handleOptionSelect(e.target.value)}
          icon={<MessageIcon />}
        />
        <FilterModalItem
          name="Status"
          data={["read", "sent", "delivered", "enqueued"]}
          value={statusFilter}
          onChange={(e) => handleStatusSelect(e.target.value)}
          icon={<FlagIcon />}
        />
        <FilterModalItem
        name="Message Type"
        data={messageTypeOptions.map((item) => item.value)}
        value={messageTypeFilter}
        onChange={(e) => handleMessageTypeSelect(e.target.value)}
        icon={<MessageIcon />}
        />
        <FilterModalItem
          name="From Date"
          type="date"
          value={appliedDateRange[0]}
          onChange={(newValue) => {
            setAppliedDateRange([newValue, appliedDateRange[1]]);
            // Check for date errors
            if (
              appliedDateRange[1] &&
              newValue &&
              dayjs(newValue).isAfter(appliedDateRange[1])
            ) {
              setDateError("From Date must be less than or equal to To Date");
            } else {
              setDateError(null);
              handleDateRangeApply();
            }
          }}
          icon={<CalendarIcon />}
        />
        <FilterModalItem
          name="To Date"
          type="date"
          value={appliedDateRange[1]}
          onChange={(newValue) => {
            setAppliedDateRange([appliedDateRange[0], newValue]);
            // Check for date errors
            if (
              appliedDateRange[0] &&
              newValue &&
              dayjs(newValue).isBefore(appliedDateRange[0])
            ) {
              setDateError(
                "To Date must be greater than or equal to From Date",
              );
            } else {
              setDateError(null);
              handleDateRangeApply();
            }
          }}
          icon={<CalendarIcon />}
        />
      </FilterModal>

      <Snackbar
        open={exportSnackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseExportSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseExportSnackbar}
          severity={exportSnackbar.severity}
          sx={{ width: "100%" }}
        >
          {exportSnackbar.message}
        </Alert>
      </Snackbar>
    </Paper>
  );
}
